/* global mainScript */
import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { motion } from "framer-motion";

// style rules
import { Animation } from "../../styles";

const CastMemberCard = ({ toggleModal, castMember, isPartOfGrid }) => {
	const { image, name, content } = castMember;

	return (
		<Card
			initial={"initial"}
			animate={"animate"}
			exit={"initial"}
			variants={Animation.cards.opacityVariants}
			onClick={() => content && toggleModal(castMember)}
			tabIndex={0}
			className="cast-member-card"
		>
			<AspectRatioBox>
				{image ? (
					<img src={image} alt={`Image for ${name}`} />
				) : (
					<img
						src={
							mainScript.assetPath + "images/png/graphics/fords-placeholder.png"
						}
						alt={"Cast member card placeholder"}
					/>
				)}
				{content && (
					<ModalButton
						width="25"
						height="25"
						viewBox="0 0 17 17"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						isLarge={!isPartOfGrid}
						type="button"
						aria-hidden="true"
					>
						<g id="Group 474">
							<circle
								id="Ellipse 1"
								opacity="0.7"
								cx="8.5"
								cy="8.5"
								r="8.5"
								fill="white"
							/>
							<g id="Group 473">
								<path
									id="Vector"
									d="M8.67354 11.6504V6.56889H8.49854H8.32354V11.6504H8.49854H8.67354Z"
									stroke="#232323"
									strokeWidth="0.35"
									strokeLinecap="round"
								/>
								<path
									id="Vector_2"
									d="M11 8.93312H6V9.10812V9.28312H11V9.10812V8.93312Z"
									stroke="#232323"
									strokeWidth="0.35"
									strokeLinecap="round"
								/>
							</g>
						</g>
					</ModalButton>
				)}
			</AspectRatioBox>
			<CardTitle dangerouslySetInnerHTML={{ __html: name }} />
		</Card>
	);
};

export default CastMemberCard;

CastMemberCard.propTypes = {
	castMember: PropTypes.object,
	toggleModal: PropTypes.func,
	isPartOfGrid: PropTypes.bool,
};

const Card = styled(motion.li)`
	position: relative;
	list-style: none;
	cursor: pointer;
	margin-bottom: 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.5rem;
`;

const AspectRatioBox = styled.div`
	position: relative;
	aspect-ratio: 185 / 192;
	overflow: hidden;
	width: 100%;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`;

const ModalButton = styled.svg`
	position: absolute;
	bottom: 1.7rem;
	right: 1.1rem;
	${(props) => props.isLarge && "width: 3.6rem; height: 3.6rem;"}
`;
const CardTitle = styled.a`
	&::after {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}
`;
